import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import { makeGetCurrentUser } from '../selectors/users';
import { makeGetCurrentTeam } from '../selectors/teams';
import { makeGetIsOnTrial, makeGetSubscriptionIsExpired, makeGetRemainingTrial, makeGetSubscriptionIsPastDue } from '../selectors/billing';

import { showModal } from '../actions/modal';

import config from '../config';
import { browserHistory } from '../services/history';
import { trackEvent } from '../services/events-tracker-service';
import { getToday } from '../utils/date';

import Alert from './alert';

class SubscriptionAlert extends PureComponent {
    handleUpgradeClick = event => {
        trackEvent('TRIAL_UPGRADE_BANNER.CLICK');
        event.preventDefault();

        showModal('SWITCH_PLAN');
    }

    handleBillingClick = event => {
        event.preventDefault();

        browserHistory.push(`/settings/team/current/billing`);
    }

    render() {
        if (this.props.isExpired) {
            return (
                <Alert type="default">
                    {
                        this.props.currentUserRole === 'owner' ?
                        config.BILLING_ENABLED ? (
                            <React.Fragment>
                                Your subscription has expired. Please upgrade to access your projects.
                            </React.Fragment>
                        ) : (
                            <React.Fragment>
                                Your subscription has expired. Please update your plan in the web app, to access your projects.
                            </React.Fragment>
                        ) : (
                            <React.Fragment>
                                The subscription for your team has expired, please reach out to your team owner to continue using Nifty.
                            </React.Fragment>
                        )
                    }
                </Alert>
            )
        }

        if (this.props.isPastDue && this.props.currentUserRole === 'owner') {
            return (
                <Alert type="default">
                    There was a problem billing your account, please <a href="" onClick={this.handleBillingClick}>update your payment details</a> to continue using Nifty without interruption.
                </Alert>
            )
        }

        if (this.props.isOnTrial && this.props.currentUserRole === 'owner' && this.props.remainingTrial <= 0) {
            return (
                <Alert type="default">
                    <strong>{this.props.remainingTrial} day{this.props.remainingTrial === 1 ? '' : 's'}</strong> left on trial. <a href="#upgrade" onClick={this.handleUpgradeClick}><strong><u>Upgrade now</u></strong></a> to keep access to your team, projects, and data.
                </Alert>
            )
        }

        return null;
    }
}

const makeMapStateToProps = () => {
    const getCurrentUser = makeGetCurrentUser();
    const getCurrentTeam = makeGetCurrentTeam();
    const getIsOnTrial = makeGetIsOnTrial();
    const getSubscriptionIsExpired = makeGetSubscriptionIsExpired();
    const getRemainingTrial = makeGetRemainingTrial();
    const getSubscriptionIsPastDue = makeGetSubscriptionIsPastDue();

    return ({ users, teams }) => {
        const currentTeam = getCurrentTeam(teams);
        const currentUser = getCurrentUser(users);
        const isOnTrial = getIsOnTrial(currentTeam);
        const remainingTrial = isOnTrial && getRemainingTrial(currentTeam, getToday().valueOf());

        return {
            currentUserRole: currentUser && currentUser.role,
            isOnTrial,
            remainingTrial,
            isExpired: currentTeam && getSubscriptionIsExpired(currentTeam),
            isPastDue: currentTeam && getSubscriptionIsPastDue(currentTeam)
        }
    };
};

export default connect(makeMapStateToProps)(SubscriptionAlert);
